import React from "react"
import { CotacoesPerdidasContainer } from "./CotacoesPerdidasContainer";

declare const window: any;

export const CotacoesPerdidasForaOrcamento = () => {
    return (
        <>
            <CotacoesPerdidasContainer regiaoRenderizada="pesquisa-cotacoes-perdidas-region" foraOrcamento />
        </>
    )
}


window.CotacoesPerdidasForaOrcamento = CotacoesPerdidasForaOrcamento